import React, { useEffect } from 'react';
import axios from 'axios';
import Grid from '@mui/material/Unstable_Grid2';

import ColorSwatches from '../components/color-swatches'
import CarModelSelector from '../components/car-model-selector'
import InfoTabs from '../components/info-tabs';
import CartButtons from '../components/cart-buttons';
import ProductInfo from '../components/product-info';
import ProductImages from '../components/product-images';
import { useSunshadeStore } from '../stores/sunshade-store';
import { PRODUCTS_TYPES_MAP } from '../constants/product';

function Sunshades() {
  const colors = useSunshadeStore(state => state.colors);
  const selectedCar = useSunshadeStore(state => state.selectedCar);
  const setSelectedCar = useSunshadeStore(state => state.setSelectedCar);
  const selectedColor = useSunshadeStore(state => state.selectedColor);
  const setSelectedColor = useSunshadeStore(state => state.setSelectedColor);
  const productVariant = useSunshadeStore(state => state.productVariant);
  const setProductVariant = useSunshadeStore(state => state.setProductVariant);
  const quantity = useSunshadeStore(state => state.quantity);
  const setQuantity = useSunshadeStore(state => state.setQuantity);
  const tabs = useSunshadeStore(state => state.tabs);

  const addToCart = async () => {
    // console.log('addToCart selectedCar', selectedCar);

    if (productVariant?.id && quantity > 0) {

      console.log('productVariant', productVariant);

      const params = {
        items: [{
          id: productVariant.id,
          quantity,
          properties: {
            Car: `${selectedCar.year} ${selectedCar.make} ${selectedCar.model} ${selectedCar.submodel?.trim}`,
            Make: selectedCar.make,
            Model: selectedCar.model,
            Trim: selectedCar.submodel?.trim,
            car_notes: selectedCar.submodel?.notes,
            _part_number: selectedCar.submodel?.part_number,
            _storage_bag: selectedCar.submodel?.storage_bag,
          }
        }]
      }

      // console.log('addToCart params', params);

      const { data } = await axios.post('/cart/add.js', params);

      // console.log('addToCart data', data);

      window.location.href = encodeURI('/cart');
    }
  }

  const getVariantForOptions = () => {
    const submodel = selectedCar?.submodel;

    if (submodel?.part_number) {
      const variants = window.conspire_product.variants;
      const selectedVariant = variants.find(
        v => v.option1 === selectedColor.name
      );

      console.log('selectedVariant', selectedVariant);
      setProductVariant(selectedVariant)
    } else {
      setProductVariant({})
    }
  }

  useEffect(() => {
    getVariantForOptions();
  }, [selectedCar.submodel, selectedColor]);

  return (
    <Grid container>
      <Grid item xs={12} md={8} className="mobile-hide">
        <section className="main-image-container">
          <ProductImages selectedColor={selectedColor} />
        </section>
        <InfoTabs tabs={tabs} />
      </Grid>
      <Grid item xs={12} md={4}>
        <ProductInfo />
        <section className="main-image-container desktop-hide">
          <ProductImages selectedColor={selectedColor} />
        </section>
        <CarModelSelector
          product={PRODUCTS_TYPES_MAP.SUNSHADES}
          selectedCar={selectedCar}
          setSelectedCar={setSelectedCar}
          productVariant={productVariant}
        />
        <ColorSwatches
          title="Colors"
          selectedColor={selectedColor}
          setSelectedColor={setSelectedColor}
          colors={colors}
          showSelectedColor
        />
        <CartButtons addToCart={addToCart} quantity={quantity} setQuantity={setQuantity} />
        <section className="info-tabs-wrapper desktop-hide">
          <InfoTabs tabs={tabs} />
        </section>
      </Grid>
    </Grid>
  )
}

export default Sunshades
